import React from "react";

import { Box, Button, Card, Grid } from '@mui/material';
import { TCInput, TCSelect } from "components/TopCourtComponents/Input/TopCourtInput";
import { AddonTypeOption, activeOption, courtOptions } from "constant/constant";
import NumberRangeInput from "components/TopCourtComponents/Input/NominalRangeFilter";
import { getCourtPlace } from "helper/LocalStorage";

export default function AddonFilter({
    filter,
    onChangeFilter,
    clearFilter
}) {

    let courtOption = courtOptions.filter(e => !e.merchantId).map(e => ({
        label: e.name,
        value: e.id
    }))

    let isMerchant = getCourtPlace().merchantId

    return (
        <Card sx={{ mb: 1 }}
            className="custom-card-style">
            <Box sx={{ justifyContent: 'center', alignItems: 'center' }}>
                {/* filter date, booking id, user, type, status */}
                <Grid container columnSpacing={2} sx={{ p: 2 }}>
                    <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                        <TCInput placeHolder="Name" onChange={(e) => onChangeFilter({ name: e.currentTarget.value })} value={filter.name} label={"Name"} />
                    </Grid>
                    <Grid item xs={12} md={isMerchant ? 4 : 3} sx={{ mb: 1 }}>
                        <NumberRangeInput
                            showLabel={true}
                            label={"Stock"}
                            placeholderStart={'Min'}
                            placeholderEnd={'Max'}
                            allowZero={false}
                            numberRangeType={filter.stockType}
                            start={filter.stockMin}
                            end={filter.stockMax}
                            onChangeSelect={(e) => onChangeFilter({ stockType: e })}
                            onChangeStart={(e) => onChangeFilter({ stockMin: e.replace(/[^0-9]+/ig, '') })}
                            onChangeEnd={(e) => onChangeFilter({ stockMax: e.replace(/[^0-9]+/ig, '') })}
                        />
                    </Grid>
                    <Grid item xs={12} md={3} sx={{ mb: 1 }}>
                        <TCSelect label={'Type'} options={AddonTypeOption} value={filter.type}
                            isMulti={true}
                            onChange={(e) => {
                                onChangeFilter({ type: e })
                            }} />
                    </Grid>
                    {
                        !isMerchant &&
                        <Grid item xs={12} md={4} sx={{ mb: 1 }}>
                            <TCSelect label={'Venue'} options={courtOption} value={filter.placeIds}
                                isMulti={true}
                                onChange={(e) => {
                                    onChangeFilter({ placeIds: e })
                                }} />
                        </Grid>
                    }
                    <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                        <TCSelect label={'Status'} options={activeOption} value={filter.status} onChange={(e) => {
                            onChangeFilter({ status: e })
                        }} />
                    </Grid>
                    <Grid item xs md={isMerchant ? 12 : undefined} sx={{ mb: 1, textAlign: 'right' }} >
                        <Button sx={{ mt: 2, border: '0.5px solid #2196f3', borderRadius: 4 }}
                            onClick={clearFilter}
                        >Clear</Button>
                    </Grid>
                </Grid>
            </Box>
        </Card>
    )
}
